import {
  ODSButton,
  type ODSButtonButtonType,
  type ODSButtonSize,
  type ODSButtonVariant,
} from '@telekom-ods/react-ui-kit';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface ButtonProps {
  type?: 'submit' | 'reset' | 'button' | undefined;
  buttonType?: ODSButtonButtonType;
  label?: string;
  size?: ODSButtonSize;
  variant?: ODSButtonVariant;
  disabled?: boolean;
  href?: string;
  download?: string | null;
  onClick?: (() => void) | null;
  icon?: ReactNode;
  leftIcon?: boolean;
  rightIcon?: boolean;
  name?: string;
}

const Button: React.FC<ButtonProps> = ({
  type = 'button',
  buttonType = 'standard',
  label,
  size = 'small',
  variant = 'primary',
  disabled = false,
  href,
  download = null,
  onClick = null,
  icon,
  leftIcon = false,
  rightIcon = false,
  name,
  ...otherProps
}) => {
  const intl = useIntl();
  const resolvedLabel = label ?? intl.formatMessage({ id: 'submit' });
  const hrefValue = download ? '' : (href ?? '');

  const odsButton = (
    <ODSButton
      type={type}
      variant={variant}
      label={resolvedLabel}
      buttonType={buttonType}
      size={size}
      disabled={disabled}
      onClick={onClick ?? undefined}
      {...(icon && { buttonIcon: icon })}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      href={hrefValue}
      name={name}
      {...otherProps}
    >
      {resolvedLabel}
    </ODSButton>
  );

  // If download is provided, wrap the button in an anchor tag
  // to enable downloading functionality
  if (download) {
    return (
      <a
        href={href ?? undefined}
        download={download}
        style={{ textDecoration: 'none' }}
      >
        {odsButton}
      </a>
    );
  }

  return odsButton;
};

export default Button;
